export default "__VITE_ASSET__Ddd5U_Nx__"